"use client";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { DownloadResumeWithModal } from "../download-resume";
import MockupFrame from "../mouheb/mockup-frame";
import { TypewriterText } from "../typewriter";
import { Button } from "../ui/button";

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="relative min-h-screen w-full flex flex-col items-center justify-between"
      id="hero"
    >
      {/* <ParticlesNewBackground
        particleCount={60}
        colors={["#ff6b6b", "#4ecdc4", "#45b7d1", "#f9ca24", "#f0932b"]}
        maxRadius={4}
        speed={0.8}
      /> */}
      <div className="mt-20 relative w-full h-full flex flex-col items-center justify-start mx-auto max-w-7xl text-center lg:text-left gap-6">
        <div
          className="dark:bg-slate-800/80 bg-emerald-200/20 backdrop-blur-sm border dark:border-emerald-500/20 rounded-full px-3 py-2"
          id="hero-title"
        >
          <span className="text-emerald-700 dark:text-[#00ff99]">
            ✨ Welcome to my portfolio
          </span>
        </div>

        {/* <ComputersCanvas /> */}

        <h1 className="text-4xl text-center md:text-6xl font-bold tracking-tight leading-light block my-3">
          <span className="opacity-100 animate-fade-in">👋 Hey, I'm</span>
          <span className="text-primary nimate-fade-in-delay-1"> Hamza</span>
          <span className="text-gradient ml-2 animate-fade-in-delay-2">
            Missaoui
          </span>
        </h1>

        <h4
          className={cn(
            "bg-gradient-to-r text-xl dark:to-purple-500 dark:from-[#00ff99] from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent animate-pulse transition-colors duration-1000 font-bold invite-link"
          )}
        >
          Software Engineer | FullStack Web Developer | Data Engineer | Cloud
          Specialist | Tester
        </h4>

        {/* <div className="mb-4 flex lg:flex-row flex-col items-center justify-center gap-4"> */}
        {/* <TypewriterText className="bg-gray-800 bg-gradient-to-r dark:from-purple-200 dark:to-pink-200 bg-clip-text text-transparent" /> */}
        <TypewriterText className="bg-gray-800 bg-gradient-to-r dark:from-amber-200 dark:to-amber-400 bg-clip-text text-transparent" />

        <div className="max-w-7xl items-start grid m-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* left column */}
          <div className="lg:col-span-2 border bg-card text-card-foreground">
            {/* <div className="my-4 flex items-center lg:items-start gap-4"> */}

            <DownloadResumeWithModal />
            {/* <SocialLinks /> */}
            {/* <SocialLinksTooltip /> */}
          </div>

          {/* right column */}
          <MockupFrame />
        </div>

        {/* <div className="order-2 lg:order-1">
          <Photo />
        </div> */}

        {/* Scroll indicator */}

        {/* <Button
        onClick={() => scrollToSection("#about")}
        className="animate-bounce mt-10 transition-colors translate-y-1 duration-1000"
        aria-label="Scroll to about section"
      >
        <ArrowDown className="w-6 h-6 mx-auto" />
      </Button> */}

        <Button
          onClick={() => scrollToSection("#about")}
          // className="animate-bounce text-primary hover:text-foreground-hover transition-colors duration-1200"
          className="animate-bounce text-black border bg-white dark:text-white dark:bg-gray-800 transition-colors duration-1200"
          // aria-label="Scroll to about section"
        >
          <ArrowDown className="w-6 h-6 mx-auto " />
        </Button>
      </div>
    </motion.section>
  );
}
